<address>
    <strong>{{ collectorName }}</strong>
    <br> {{ address.address1 }}
    <br> {{ address.address2 }}
    @if (address.address2) {
        <br>
    } 
    {{ address.city }}
    @if (address.city) {
    <span>, </span>
    }
    {{ address.abbr }} {{ address.zip }}
</address>